<template>
  <div :loading="saveLoad" class="app-container">
    <div class="formLine">活动集客信息</div>
    <div class="budgetBox">
      <el-form ref="actCustomer" class="UniformCss" :inline="true" :model="actCustomer" :rules="rules" label-width="120px">
        <el-row class="flex-row">
          <el-col :span="8">
            <el-form-item label="活动编码" prop="actCode">
              <el-input v-model="actCustomer.actCode" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>
          <!--<el-col :span="8">
            <el-form-item label="活动类型" prop="actType">
              <el-input v-model="actCustomer.actType" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>-->
          <el-col :span="8">
            <el-form-item label="客户姓名" prop="customerName">
              <el-input v-model="actCustomer.customerName" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="actCustomer.mobile" type="number" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>
          <!--<el-col :span="8">
            <el-form-item label="微信号" prop="wechat">
              <el-input v-model="actCustomer.wechat" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="actCustomer.email" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其他联系方式" prop="others">
              <el-input v-model="actCustomer.others" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>-->
          <el-col :span="8">
            <el-form-item label="品系" prop="seriesCode">
              <el-select v-model="actCustomer.seriesCode" :disabled="viewDisabled" @change="selectChange">
                <el-option v-for="item in seriesList" :key="item.strainsCode" :label="item.strains" :value="item.strainsCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="车系" prop="subSeriesCode">
              <el-select v-model="actCustomer.subSeriesCode" :disabled="viewDisabled" @click.native="handleSub">
                <el-option v-for="item in subSeriesList" :key="item.carSeriesCode" :label="item.carSeries" :value="item.carSeriesCode" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="8">
            <el-form-item label="意向购车时间" prop="intendedDate">
              <el-date-picker
                v-model="actCustomer.intendedDate"
                :disabled="viewDisabled"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                style="width: 195px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型" prop="seriesCode">
              <el-select v-model="actCustomer.type" :disabled="viewDisabled">
                <el-option label="商家录入" value="1" />
                <el-option label="客户录入" value="2" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item prop="dealerName">
              <label slot="label"><span class="el-item-label">所属经销商</span></label>
              <el-input v-model="actCustomer.dealerName" :disabled="viewDisabled" style="width: 195px" @focus="chooseDealer" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="16">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" v-model="actCustomer.remark" :disabled="viewDisabled" clearable />
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div class="btn-container">
        <vxe-button status="primary" @click="returnFun()">返回</vxe-button>
        <vxe-button v-if="!viewDisabled"  status="success" @click="onSubmit()">保存</vxe-button>
      </div>
    </div>
    <el-dialog title="选择经销商" :visible.sync="dealerDialogVisible" width="50%">
      <div style="margin-bottom: 20px">
        <el-input v-model="dealerName" placeholder="输入经销商名称" clearable :style="{ width: '80%' }" @change="findDealers" />
        <vxe-button status="primary" icon="el-icon-search" class="filter-search-item" style="float: right" @click="findDealers">查询</vxe-button>
      </div>
      <vxe-table
        ref="Xdealer"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="dealerLoading"
        max-height="370"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="dealerLists"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
        :radio-config="{ strict: false, labelField: 'seq', trigger: 'row', isCurrent: true, isHover: true }"
      >
        <vxe-column type="radio" width="60" />
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="id" title="经销商ID" width="110" />
        <vxe-column field="name" title="经销商名称" width="220" />
        <vxe-column field="address" title="地址" />
      </vxe-table>
      <vxe-pager
        :loading="dealerLoading"
        :current-page="addTablePage.currentPage"
        :page-size="addTablePage.pageSize"
        :total="addTablePage.totalResult"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handleAddPageChange"
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dealerDialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" @click="handleChooseDealer">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { detailActCustomer, saveActCustomer } from '@/api/activityCustomer'
import { queryCarStrainsInfo } from '@/api/activity'
import { findDealers } from '@/api/amount'

const defaultactCustomer = {
  id: '',
  actCode: '',
  actType: '',
  customerName: '',
  mobile: '',
  wechat: '',
  email: '',
  others: '',
  seriesCode: '',
  subSeriesCode: '',
  intendedDate: '',
  dealerId: '',
  dealerName: '',
  type: '',
  remark: ''
}

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  name: 'ActCustomerDetail',
  data() {
    return {
      seriesList: [], // 品系
      subSeriesList: [], // 车系
      actCustomer: Object.assign({}, defaultactCustomer),
      rules: {
        actCode: [{ required: true, message: '请输入活动编码', trigger: 'blur' }],
        actType: [{ required: true, message: '请输入活动类型', trigger: 'blur' }],
        customerName: [{ required: true, message: '请输入客户姓名', trigger: 'blur' }],
        seriesCode: [{ required: true, message: '请选择品系', trigger: 'blur' }],
        subSeriesCode: [{ required: true, message: '请选择车系', trigger: 'blur' }],
        intendedDate: [{ required: true, message: '请选择意向购车时间', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        dealerName: [{ required: true, trigger: 'blur', message: '请选择所属经销商' }]
      },
      viewDisabled: false,
      saveLoad: false,
      dealerDialogVisible: false,
      pagination: Object.assign({}, defaultPagination),
      dealerName: '',
      dealerLoading: false,
      dealerLists: [],
      addTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      seriesCode: '',
      subSeriesCode: ''
    }
  },
  created() {
    // 获取品系列表
    // this.getSeriesList()
    // this.getSubSeriesList()
    this.getSeriesList()
    if (this.$route.params.id) {
      this.actCustomer.id = this.$route.params.id
      this.getActCutomer()
    }
    if (this.$route.params.seriesCode) {
      this.seriesCode = this.$route.params.seriesCode
      // this.getSubSeriesList()
    }
    if (this.$route.params.type === 'view') {
      this.viewDisabled = true
    }
  },
  methods: {
    getActCutomer() {
      detailActCustomer(this.actCustomer.id).then(res => {
        this.actCustomer = res.data
      })
    },
    getSeriesList() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.seriesList = res.data.list
        }
      })
    },
    // getSubSeriesList() {
    //   const data = { strainsCodes: this.seriesCode }
    //   queryCarSeriesInfo(data).then(res => {
    //     if (res.code === 1) {
    //       this.subSeriesList = res.data.list
    //     }
    //   })
    // },
    selectChange(val) {
      this.actCustomer.subSeriesCode = ''
      this.subSeriesList = []
      this.seriesCode = val
      // this.getSubSeriesList()
    },
    handleSub() {
      if (this.actCustomer.seriesCode == null || this.actCustomer.seriesCode === '') {
        this.$message('请先选择品系')
      }
    },
    chooseDealer() {
      this.dealerDialogVisible = true
      this.findDealers()
    },
    findDealers() {
      this.dealerLoading = true
      const param = {
        page: this.addTablePage.currentPage,
        limit: this.addTablePage.pageSize,
        paramMap: {
          dealerName: this.dealerName
        }
      }
      findDealers(param).then(res => {
        if (res.code === 1 && res.data) {
          this.dealerLists = res.data.list
          this.addTablePage.totalResult = res.data.total
          this.dealerLoading = false
        }
      })
    },
    handleAddPageChange({ currentPage, pageSize }) {
      this.addTablePage.currentPage = currentPage
      pageSize !== this.addTablePage.pageSize && (this.addTablePage.currentPage = 1)
      this.addTablePage.pageSize = pageSize
      this.findDealers()
    },
    handleChooseDealer() {
      const data = this.$refs['Xdealer'].getRadioRecord()
      if (data) {
        this.actCustomer.dealerName = data.name
        this.actCustomer.dealerId = data.id
      }
      this.dealerDialogVisible = false
    },
    onSubmit() {
      this.$refs.actCustomer.validate((valid) => {
        if (valid) {
          if (!this.actCustomer.mobile && !this.actCustomer.wechat && !this.actCustomer.email) {
            this.$message('手机号，微信，邮箱至少输入一个')
            return
          }
          const params = Object.assign({}, this.actCustomer)
          saveActCustomer(params).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.returnFun()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message('请完善信息!')
        }
      })
    },
    returnFun() {
      this.returnListFun()
    },
    returnListFun() {
      // 跳转路由
      this.$closePage('/terminalActivity/actCustomerDetail', '/terminalActivity/actCustomerList')
    },
  }
}
</script>

<style lang="less" scoped>
.formLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.btn-container {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
/deep/ .el-input__inner {
  height: 30px!important;
}
.flex-row {
  display: flex;
  flex-wrap: wrap;
}
/deep/.el-form-item {
  display: flex;
}
</style>
